<template>
	<el-drawer :modal="false" :visible.sync="showMessagingDrawer" class="messaging-drawer" size="45%"
		:title="message_profile ? (message_profile.profile_name + ' Message') : 'Message'" @close="cleanMessageDrawer"
		v-if="_gAuth.activeUser('subscription.privileges.scpk_crm_chat_massage',false)">
		<b-container>
			<chats></chats>
			<!-- <el-tabs>
                <el-tab-pane>
                    <chats></chats>
                </el-tab-pane>
                <el-tab-pane label="Files">
                    <messaging-documents :key="key.messaging_documents"></messaging-documents>
                </el-tab-pane>
                <el-tab-pane label="Activity Log" disabled>
                    <activity-logs></activity-logs>
                </el-tab-pane>
            </el-tabs> -->
		</b-container>
	</el-drawer>
</template>
<script>
import { Drawer, Option, Select, Tabs, TabPane } from 'element-ui'
import Chats from '@/views/Messaging/Chats/MessagingChats'
// import MessagingDocuments from '@/views/Messaging/Documents/MessagingDocuments'
// import ActivityLogs from '@/views/Messaging/Logs/MessagingLogs'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'

export default {
	components: {
		Chats,
		// MessagingDocuments,
		// ActivityLogs,
		[Drawer.name]: Drawer,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	data() {
		return {
			showMessagingDrawer: false,
			// key:{
			//     messaging_documents: 1
			// },
		}
	},
	computed: {
		...mapState(useMessagingStore, ['message_profile']),
	},
	methods: {
		...mapActions(useMessagingStore, ['getGroupMessageList', 'setMessageProfile', 'resetMessages', 'setSelectedGroup', 'updateLoadingMessage', 'getAvailableUserByProfile']),
		viewMessagingDrawer(data) {
			this.updateLoadingMessage(true)
			this.showMessagingDrawer = true;
			this.resetMessages()
			this.setSelectedGroup(null);
			this.setMessageProfile(data.profile)

			this.getGroupMessageList(data.bundle_key).then(async(resp) => {
				await this.getAvailableUserByProfile()
				chatEventBus.$emit('go-back-to-chat-main')
				this.updateLoadingMessage(false)
			})
		},
		cleanMessageDrawer() {
			this.resetMessages()
			this.setMessageProfile(null);
			this.setSelectedGroup(null);
		}
	}
}
</script>